module.exports = __webpack_public_path__ + "media/images/font/Gustavo-Italic-017b6a3cc58c6ee813d27bcace467759.woff";